import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostKundenGruppeCommandServiceModule } from '..';
import { PostKundenGruppeCommandComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    PostKundenGruppeCommandServiceModule
  ],
  declarations: [PostKundenGruppeCommandComponent],
  exports: [PostKundenGruppeCommandComponent],

})
export class PostKundenGruppeCommandComponentModule { }
